var map = {
	"./01.png": "LdeV",
	"./02.png": "ZDii",
	"./03.png": "ih5A",
	"./04.png": "AOcr",
	"./05.png": "CVoW",
	"./googel.png": "DcDs",
	"./logo.png": "7Otq",
	"./map.png": "/PMo",
	"./qr-code.png": "li4h",
	"./qr-code1.png": "RrsB",
	"./ramadankenzy.png": "qQCu",
	"./ramadanstyle.png": "D7bZ",
	"./under-maintenance1.png": "QDBi",
	"./under_construction.png": "6Mq2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEjn";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = BEjn
// module chunks = 7